import { EInvoiceSenderComplianceMessage } from "bookkeeping/detail/EInvoiceSenderComplianceMessage";
import { SidePanelDetailSectionTemplate } from "components/MainSectionTemplate/SidePanelSection/SidePanelDetailSectionTemplate";
import { CompanySmallDetails } from "components/SmallDetails";
import React from "react";
import { BankAccountsSection } from "./BankAccountsSection";

interface BookkeepingSidePanelDetailsProps {
  bookkeeping: server.dto.BookkeepingSidePanelData
}

export const BookkeepingSidePanelDetails = (props: BookkeepingSidePanelDetailsProps) => {
  const { bookkeeping, bankAccounts, eInvoiceCompliance } = props.bookkeeping;

  return <SidePanelDetailSectionTemplate
    isInPageEditable={false}
    onValueChanged={() => { }}
    fields={[{
      key: "name",
      label: RESX.GeneralLabels.Name,
      render: () => <>{bookkeeping.name}</>
    }, {
      key: "code",
      label: RESX.Bookkeeping.Code,
      render: () => <>{bookkeeping.code}</>
    }, {
      key: "company",
      label: RESX.Company.resxCompany,
      render: () => <CompanySmallDetails
        company={bookkeeping.company}
        layout="multiLine"
      />
    }, {
      key: "eInvoiceCompliance",
      label: "Peppol",
      hidden: eInvoiceCompliance.value === "countryNotSupported",
      render: () => <EInvoiceSenderComplianceMessage
        compliance={eInvoiceCompliance}
      />
    }]}
    additionalContent={<>
      <BankAccountsSection bankAccounts={bankAccounts} />
    </>}
  />
}